import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class SculptorBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.SCULPTOR;
}

export default SculptorBuildingTileEntity;
